import React, { useState, useEffect } from 'react'
import Button from "../Button/Button"
import FiltersInputLine from "./FiltersInputLine"

import ModalComponent from "../Modal/Modal"
import Input from "../Input/Input"
import { createFilterList } from "../../features/customer/customerSlice"
import { useDispatch, useSelector } from "react-redux"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"
import { REQUEST_ERRORS_LISTS } from "../../constants/requestErrorFlags"
import { showSnackBar } from "../Snackbar/Snackbar"
import { ClickAwayListener } from "@mui/base"

const FiltersModal = ({
  filters,
  utils,
  fetchFilters,
  requestFilters,
  initQueryData,
  setIsOpenFilters,
  isOpenFilters,
  clickOnButton,
  setClickOnButton,
  setIsOpenFilterList,
  isFilterList,
  userRole,
  setUtils,
  flow = '',
}) => {
  const dispatch = useDispatch()
  const listStrict = useSelector(selectFeatureFlag(REQUEST_ERRORS_LISTS))

  const [newFilterListLabel, setNewFilterListLabel] = useState('')
  const [localFilters, setLocalFilters] = useState(requestFilters)

  useEffect(() => {
    setLocalFilters(requestFilters)
  }, [requestFilters])

  const handleClickOutside = () => {
    // A dropdown inside this panel opens its menu in a portal that also mounts an invisible,
    // full-viewport backdrop. Press the dropdown and the backdrop appears under the cursor
    // before the button comes back up, so mousedown and mouseup land on different elements
    // and the browser dispatches the click at their common ancestor — <body>. That is
    // outside this panel by every measure ClickAwayListener has, so choosing a filter closed
    // the panel that owns the menu. While such a menu is open the click belongs to it, not
    // to us; MUI closes the menu itself.
    if (document.querySelector('.MuiModal-root')) {
      return
    }
    if (isOpenFilters) {
      setIsOpenFilters(false)
    }
  }

  const addItem = () => {
    setLocalFilters([...localFilters, initQueryData])
  }

  const deleteItem = (i) => {
    if (localFilters.length <= 1) {
      setLocalFilters([initQueryData])
      return
    }
    const newVal = [...localFilters]
    newVal.splice(i, 1)
    setLocalFilters(newVal)
  }

  const handleRequestFilterChange = (i, { fieldName, operator, value, filterType }) => {
    setLocalFilters(prevFilters =>
      prevFilters.map((filter, index) =>
        index === i
          ? {
            ...filter,
            fieldName: fieldName || filter.fieldName,
            operator: operator || filter.operator,
            value: value ?? filter.value,
            filterType: filterType || filter.filterType,
          }
          : filter
      )
    );
  };
  const saveNewList = async () => {
    try {
      const response = await dispatch(createFilterList({ label: newFilterListLabel, flow, filters: localFilters }))
      if (listStrict && response?.error) {
        showSnackBar("error", typeof response.payload === 'string' ? response.payload : 'Failed to create filter list')
        return
      }
      setIsOpenFilters(false)
      showSnackBar("success", "Filter list successfully created ")
    } catch (error) {
      console.error(error)
    }
  }

  const fetchByFilters = async () => {
    fetchFilters(localFilters)
    setIsOpenFilters(false)
    setIsOpenFilterList(false)
  }

  useEffect(() => {
    if (clickOnButton) {
      setIsOpenFilters(true)
      setClickOnButton(false)
    }
    setIsOpenFilterList(false)
  }, [isOpenFilters])
  return (
    <ClickAwayListener onClickAway={handleClickOutside}>
      <div className="fixed rounded-2xl p-6 min-w-[680px] max-w-[min(1100px,calc(100vw-320px))] w-max bg-paper mb-[65px] z-[999] ml-[-60px] shadow-custom overflow-x-auto">
        <div className="border border-divider border-x-0 border-t-0 text-lg pb-2.5 text-text-secondary">
          Filters
        </div>
        <div className="py-9">
          {localFilters?.map((val, index) =>
            <FiltersInputLine key={index} filters={filters} utils={utils} deleteItem={() => deleteItem(index)}
              index={index} handleRequestFilterChange={handleRequestFilterChange} filterLine={val}
              userRole={userRole} setUtils={setUtils} />
          )}
          <div className="w-full flex flex-row justify-end">
            <Button onClick={addItem} type="text" styles={{ marginRight: '-14px' }}>+Add New Filter</Button>
          </div>
        </div>
        <div className="w-full flex flex-row">
          {isFilterList && <ModalComponent modalButtonTitle="Save" buttonType="outlined" buttonTitleStyle="flex justify-center"
            title="Add label for a new filters list"
            functionButton={saveNewList} buttonTitle="Save As New List" buttonWidth="w-full mr-6"
            modalWidth="w-full mr-6">
            <Input width="w-full" placeholder="Enter filters list name" label="Name" value={newFilterListLabel}
              onChange={(e) => setNewFilterListLabel(e.target.value)} />
          </ModalComponent>}
          <Button onClick={fetchByFilters} type="outlined" width="w-full">Apply Filter</Button>
        </div>
      </div>
    </ClickAwayListener>
  )
}

export default FiltersModal
